import { FundScreenerSessionResponse } from '@repo/tools-types'
import { AxiosInstance } from 'axios'

export const createFundScreenerSession = async ({ api }: { api: AxiosInstance }) =>
  api.post<FundScreenerSessionResponse>('/tools/fund-screener/session')
